exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".md-top {\n    margin-top: 10px;\n}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ../~/css-loader!./app/components/group/group.component.css
// module id = 851
// module chunks = 0